import { render, staticRenderFns } from "./BoardGovernance.vue?vue&type=template&id=fa69a51c&scoped=true&"
import script from "./BoardGovernance.vue?vue&type=script&setup=true&lang=js&"
export * from "./BoardGovernance.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa69a51c",
  null
  
)

export default component.exports